module.exports = __webpack_public_path__ + "static/img/zizhu.d4f60d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zizhu.png
// module id = 4vrj
// module chunks = 1